import React, { useCallback, useContext, useLayoutEffect } from 'react';
import {
  GridRenderCellParams,
  GridRowModel,
  useGridApiContext,
} from '@mui/x-data-grid-pro';
import { IClientBusinessModel } from '../../../../../../../Types/ClientModelTypes';
import { useItemFunctionMenuItemsType } from '../../../../../../../Utils/ObjektVyUtils';
import { IBusinessListIconDef } from '../../../../Const/BusinessConfigs';
import FunctionItem from '../../../FunctionMenu/FunctionItem/FunctionItem';
import FunctionMenuItemsRenderProp from '../../../FunctionMenu/FunctionMenuItemsRenderProp/FunctionMenuItemsRenderProp';
import FunctionMenu from '../../../FunctionMenu/FunctionMenu/FunctionMenu';
import { useIsTouchDevice } from '../../../../../../../Components/BreakpointContext/BreakpointContextUtils';
import { TableEditModeContext } from '../BusinessDataTable';

interface IProps {
  useFunktionsMenyItems: useItemFunctionMenuItemsType | undefined;
  hideDefaultFunktionsMenyItems?: boolean;
  collection: IClientBusinessModel;
  associationName?: string;
  disabled: boolean;
  businessIcons: IBusinessListIconDef[];
  renderCellParams: GridRenderCellParams;
  funtionMenuClassName: string;
  row: GridRowModel;
  tableEditable?: boolean;
}

const BusinessDataTableMenuCell: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const id = props.renderCellParams.id as string;
  const isTouchDevice = useIsTouchDevice();
  const tableEditMode = useContext(TableEditModeContext);
  const params = props.renderCellParams;
  const ref = React.useRef<HTMLButtonElement | null>(null);
  const api = useGridApiContext();

  const focusCell = useCallback(() => {
    if (!params.hasFocus) api.current.setCellFocus(params.id, params.field);
  }, [api, params.field, params.hasFocus, params.id]);

  useLayoutEffect(() => {
    if (
      params.hasFocus &&
      ref.current &&
      document.activeElement !== ref.current &&
      tableEditMode.editMode === true
    ) {
      ref.current.focus();
    }

    if (
      params.hasFocus &&
      api.current.getRowMode(params.rowNode.id) === 'view' &&
      tableEditMode.editMode === true
    ) {
      //sätt rowEdit om det inte är satt
      api.current.startRowEditMode({ id: params.rowNode.id });
    }

    if (
      params.hasFocus &&
      ref.current &&
      document.activeElement === ref.current &&
      params.cellMode === 'view' &&
      tableEditMode.editMode === false
    ) {
      ref.current.blur();
    }
  }, [
    params.hasFocus,
    params.cellMode,
    tableEditMode.editMode,
    params.rowNode.id,
    api,
  ]);
  return (
    <>
      {props.businessIcons &&
        props.businessIcons.map(icon =>
          icon.componentFn({
            id: id,
            data: props.renderCellParams.row.collectionData || {
              _version: 0,
              id: 'NoCollectiondata',
            },
            disabled: props.disabled,
          })
        )}
      <FunctionMenuItemsRenderProp
        id={id}
        collection={props.collection}
        associationName={props.associationName}
        item={props.row.collectionData}
        useFunktionsMenyItems={props.useFunktionsMenyItems}
        hideDefaultFunktionsMenyItems={props.hideDefaultFunktionsMenyItems}
      >
        {funktionsMenyItems => (
          <FunctionMenu
            id={id}
            buttonRef={ref}
            collection={props.collection}
            className={props.funtionMenuClassName}
            onlyOnHover={!isTouchDevice && !props.tableEditable}
            padding="dense"
            disabled={props.disabled}
            disableTabbing={!tableEditMode.editMode}
            onFocus={focusCell}
          >
            {funktionsMenyItems.map(funktionsMenyItem => (
              <FunctionItem
                key={funktionsMenyItem.id}
                onClick={funktionsMenyItem.onClick}
                disabled={funktionsMenyItem.disabled}
                disabledReason={funktionsMenyItem.disabledReason}
                iconType={funktionsMenyItem.iconType}
                listItemIcon
                confirmButtonCaption={funktionsMenyItem.confirmButtonCaption}
                confirmDialogCaption={funktionsMenyItem.confirmDialogCaption}
                confirmDialogMessage={funktionsMenyItem.confirmDialogMessage}
              >
                {funktionsMenyItem.caption}
              </FunctionItem>
            ))}
          </FunctionMenu>
        )}
      </FunctionMenuItemsRenderProp>
    </>
  );
};

export default BusinessDataTableMenuCell;
